import cn from 'classnames';
import React from 'react';

import FormattedPrice from 'components/basic/FormattedPrice';
import { BodyM, H3 } from 'components/domains/typography/Typography';

import type { CurrencyEnum } from '../FormattedPrice';

import styles from './styles.module.scss';

export const ProductSubTitle: React.FC<{
  currency: CurrencyEnum;
  name: string;
  isCurrent?: boolean;
  interval: string;
  price: string | number | null;
  priceInterval?: string;
  className?: string;
}> = ({ name, isCurrent, className, interval, price, currency, priceInterval = 'month' }) => {

  let intervalValue;
  let intervalText;
  if (/year/.test(interval) === true) {
    if (priceInterval === 'month') {
      intervalValue = 1;
      if (interval === 'year') {
        intervalValue = 12;
      }
      else if (interval === '2-year') {
        intervalValue = 24;
      }
  
      intervalText = 'month';
    }
    else if (priceInterval === 'day') {
      intervalValue = 30;
      if (interval === 'year') {
        intervalValue = 365;
      }
      else if (interval === '2-year') {
        intervalValue = 730;
      }
  
      intervalText = 'day';
    }
  }

  return (
    <div className={cn(styles.secondLineWrapper, className)}>
      <BodyM
        className={cn(styles.description, {
          [styles.currentPlanDescription]: isCurrent,
        })}
      >
        {name}
      </BodyM>
      {((price !== null && +price > 0) && !isCurrent && intervalValue && intervalText) ? (
        <H3 className={cn(styles.intevalPrice, { [styles.monthPrice]: priceInterval === 'month' })}>
          <FormattedPrice
            price={(+price / intervalValue).toFixed(2)}
            currency={currency}
          />
          / {intervalText}
        </H3>
      ) : null}
    </div>
  );
};

ProductSubTitle.displayName = 'Payments/ProductSubTitle';
